/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClickerSession } from '../../models/clicker-session';
import { OpenClickerSessionDto } from '../../models/open-clicker-session-dto';

export interface ClickerSessionsControllerOpenSession$Params {
      body: OpenClickerSessionDto
}

export function clickerSessionsControllerOpenSession(http: HttpClient, rootUrl: string, params: ClickerSessionsControllerOpenSession$Params, context?: HttpContext): Observable<StrictHttpResponse<ClickerSession>> {
  const rb = new RequestBuilder(rootUrl, clickerSessionsControllerOpenSession.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ClickerSession>;
    })
  );
}

clickerSessionsControllerOpenSession.PATH = '/clicker/sessions/open';
